import { render, staticRenderFns } from "./UserWidget.vue?vue&type=template&id=b32f7c16&scoped=true&"
import script from "./UserWidget.vue?vue&type=script&lang=js&"
export * from "./UserWidget.vue?vue&type=script&lang=js&"
import style0 from "./UserWidget.vue?vue&type=style&index=0&id=b32f7c16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32f7c16",
  null
  
)

export default component.exports